import { createTheme } from "@mui/material/styles";

export const getTheme = (mode) =>
  createTheme({
    palette: {
      mode,
      primary: { main: "#FFA500" }, // Golden Orange
      secondary: { main: "#2E8B57" }, // Green
      background: {
        default: mode === "light" ? "#ffffff" : "#121212",
        paper: mode === "light" ? "#f9f9f9" : "#1e1e1e",
      },
      text: {
        primary: mode === "light" ? "#1a1a1a" : "#ffffff",
        secondary: mode === "light" ? "#555555" : "#cccccc",
      },
    },
    typography: { fontFamily: "Roboto, Arial, sans-serif" },
  });
